import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';
import { DeviceTable, type Device } from '../../components/Admin/DevicesPage';

export default function ClientDevicesTab({ tenantId }: { tenantId: string }) {
  const { t, i18n } = useTranslation();
  const [devices, setDevices] = useState<Device[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get('/admin/devices')
      .then(({ data }) => { if (!cancelled) setDevices((data as Device[]).filter(d => d.tenantId === tenantId)); })
      .catch(() => { if (!cancelled) setError(t('devices.loadError')); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [tenantId]);

  return (
    <div>
      <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>{t('devices.title')}</h2>

      {error && <div className="error-message" style={{ marginBottom: 14 }}>{error}</div>}

      {loading ? (
        <div style={{ color: 'var(--gray)', fontSize: 13, padding: '12px 0' }}>...</div>
      ) : devices.length === 0 ? (
        <div style={{ color: 'var(--gray)', fontSize: 13, padding: '12px 0' }}>{t('devices.noneActive')}</div>
      ) : (
        // onAssign no aplica acá: esta tab solo muestra devices YA reclamados
        // por este tenant (reasignar/desreclamar es fuera de alcance por ahora).
        // showTenantColumn=false: ya está scopeado a un solo cliente, la columna es redundante.
        <DeviceTable devices={devices} onAssign={() => {}} t={t} i18n={i18n} showTenantColumn={false} />
      )}
    </div>
  );
}
